import {
  QueryObserverResult,
  RefetchOptions,
  RefetchQueryFilters,
  useQuery,
} from '@tanstack/react-query';

import { API_HANDLERS } from 'api/apiHandlers';
import { FolderUsageResponse } from 'api/types';

interface UseFolderUsageQueryParams {
  folderId: string;
  enabled: boolean;
}

interface UseFolderUsageQueryReturn {
  data: FolderUsageResponse | undefined;
  isLoading: boolean;
  refetch: <TPageData>(
    options?: RefetchOptions & RefetchQueryFilters<TPageData>,
  ) => Promise<QueryObserverResult<FolderUsageResponse, unknown>>;
}

export function useFolderUsageQuery({
  folderId,
  enabled,
}: UseFolderUsageQueryParams): UseFolderUsageQueryReturn {
  const { data, isLoading, refetch } = useQuery(
    ['folder-usage', folderId],
    () => API_HANDLERS.FOLDERS.GET_USAGE(folderId).then((res) => res.data),
    { enabled },
  );

  return { data, isLoading, refetch };
}
